import { createContext } from 'react'

interface AncillaryContextData {
  ancillary: Ancillary.Item
}

const AncillaryContext = createContext<AncillaryContextData>({ ancillary: null as any })

export default AncillaryContext
